import { render, staticRenderFns } from "./TextualArray.vue?vue&type=template&id=31ea9e38"
import script from "./TextualArray.vue?vue&type=script&lang=js"
export * from "./TextualArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports